import {Paper, Text} from 'common/components'
import {TestForm, TestResult, useGetTestData} from '.'

export default function Calculations() {
  const {mutate: getTestData, data: result, isMutating} = useGetTestData()

  return (
    <Paper fullHeight>
      <div>
        <Text as="h1" size="2xl" weight="bold" mb={24}>
          Calculation result test
        </Text>
        <TestForm isMutating={isMutating} getTestData={getTestData} />
        {result && <TestResult result={result} />}
      </div>
    </Paper>
  )
}
